<template>
  <div class="dashboard-loading" ...attributes>
    <div class="main-box loading-box">
      <div class="controls"></div>
      <div class="content"></div>
    </div>
    <div class="report-box loading-box"></div>
    <div class="courses-box loading-box"></div>
  </div>
</template>
